import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { Link, useParams } from 'react-router-dom';

import { obtenirDeploiementParId } from './deploiementApi';

function afficherObjet(objet) {
  if (!objet || typeof objet !== 'object') {
    return <Typography variant="body2">Aucune donnee.</Typography>;
  }
  return Object.keys(objet).map((cle) => (
    <Typography key={cle} variant="body2" style={{ marginTop: 6 }}>
      <strong>{cle}:</strong> {String(objet[cle])}
    </Typography>
  ));
}

function DeploiementReportDetails() {
  const { id } = useParams();
  const [rapport, setRapport] = useState(null);
  const [chargement, setChargement] = useState(true);
  const [erreur, setErreur] = useState('');
  const isMobile = window.innerHeight > window.innerWidth;

  useEffect(() => {
    let actif = true;
    setChargement(true);
    setErreur('');
    obtenirDeploiementParId(id)
      .then((data) => {
        if (!actif) return;
        setRapport(data);
      })
      .catch((err) => {
        if (!actif) return;
        setErreur(err.message || 'Impossible de charger le rapport.');
      })
      .finally(() => {
        if (actif) setChargement(false);
      });
    return () => { actif = false; };
  }, [id]);

  return (
    <Container maxWidth={false} className={isMobile ? 'conteneur-accueil-mobile' : 'conteneur-accueil'}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Button component={Link} to="/Ingenierie/Deploiements" variant="outlined">Retour a la liste</Button>
        </Grid>
        <Grid item xs={12}>
          <Paper style={{ padding: 16 }}>
            <Typography variant="h5">Detail du rapport de deploiement</Typography>
            <Typography variant="body2" color="textSecondary">Identifiant: {id}</Typography>
            <Divider style={{ marginTop: 12, marginBottom: 12 }} />

            {chargement && <CircularProgress size={24} />}
            {erreur && <Typography color="error">{erreur}</Typography>}

            {!chargement && !erreur && rapport && (
              <div>
                <Typography variant="subtitle1">Informations generales</Typography>
                {afficherObjet({
                  dateRapport: rapport.dateRapport || rapport.createdAt || '-',
                  environnementCible: rapport.environnementCible || '-',
                  operateur: rapport.operateur || '-',
                  decisionFinale: rapport.decisionFinale || '-',
                })}

                <Divider style={{ marginTop: 12, marginBottom: 12 }} />
                <Typography variant="subtitle1">Reference version</Typography>
                {afficherObjet(rapport.referenceVersion || {})}

                <Divider style={{ marginTop: 12, marginBottom: 12 }} />
                <Typography variant="subtitle1">Validation Plesk</Typography>
                {afficherObjet(rapport.validationsPlesk || {})}

                <Divider style={{ marginTop: 12, marginBottom: 12 }} />
                <Typography variant="subtitle1">Validation DB / migration / rollback</Typography>
                {afficherObjet(rapport.validationsBaseDonnees || {})}

                <Divider style={{ marginTop: 12, marginBottom: 12 }} />
                <Typography variant="subtitle1">Validation post-deploiement</Typography>
                {afficherObjet(rapport.validationsPostDeploiement || {})}

                {Array.isArray(rapport && rapport.rapport && rapport.rapport.sections) && (
                  <div>
                    <Divider style={{ marginTop: 12, marginBottom: 12 }} />
                    <Typography variant="subtitle1">Sections du rapport structure</Typography>
                    {rapport.rapport.sections.map((section, index) => (
                      <Paper key={section.nom || index} style={{ marginTop: 10, padding: 12, background: '#f9f9f9' }}>
                        <Typography variant="body1"><strong>{section.nom || ('Section ' + (index + 1))}</strong></Typography>
                        {afficherObjet(section.contenu)}
                      </Paper>
                    ))}
                  </div>
                )}
              </div>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default DeploiementReportDetails;



// WEBPACK FOOTER //
// src/components/deploiements/DeploiementReportDetails.js